import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';

const whatsappUrl = 'https://wa.link/q56ehu';

export const WhatsAppBubble: React.FC = () => {
  const reduceMotion = useReducedMotion();

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar com a Hiperbite pelo WhatsApp"
      initial={reduceMotion ? false : { opacity: 0, scale: 0.8, y: 16 }}
      animate={reduceMotion ? undefined : { opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.45, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
      whileHover={reduceMotion ? undefined : { scale: 1.06, y: -3 }}
      whileTap={reduceMotion ? undefined : { scale: 0.96 }}
      className="group fixed bottom-5 right-5 z-[60] flex h-14 w-14 items-center justify-center rounded-full border border-[#91e6a7]/40 bg-[#25D366] text-[#06130a] shadow-[0_12px_35px_rgba(37,211,102,0.28)] outline-none transition-shadow hover:shadow-[0_16px_45px_rgba(37,211,102,0.42)] focus-visible:ring-2 focus-visible:ring-[#25D366] focus-visible:ring-offset-2 focus-visible:ring-offset-[#0b0b0c] sm:bottom-7 sm:right-7"
    >
      {!reduceMotion && <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366]/30 [animation-duration:2.8s]" aria-hidden="true" />}
      <MessageCircle className="h-6 w-6 fill-current" aria-hidden="true" />
      <span className="pointer-events-none absolute bottom-full right-0 mb-3 w-max max-w-[calc(100vw-2rem)] translate-y-1 border border-white/15 bg-[#151516]/95 px-3 py-2 font-mono text-[10px] uppercase tracking-[0.12em] text-white/80 opacity-0 shadow-xl backdrop-blur-xl transition duration-200 group-hover:translate-y-0 group-hover:opacity-100 group-focus-visible:translate-y-0 group-focus-visible:opacity-100">
        Falar pelo WhatsApp
      </span>
    </motion.a>
  );
};
